module.exports = __webpack_public_path__ + "static/media/yes.d91471a6.svg";